<template>

    <div class="error-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="error-content">
                        <h1>404</h1>
                        <h2>Oops! That page can’t be found</h2>
                        <p>The page you are looking for doesn't exist :(</p>
                        <div class="button">
                            <router-link to="/" class="btn">Go To Home</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "NotFound",
        metaInfo: {
            title: "Tribinnov Africa - Page Not Found"
        }
    }
</script>